import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import admin from './modules/admin'
import process from './modules/processes'
import tasks from './modules/tasks'
import users from './modules/users'
import groups from './modules/groups'
import files from './modules/files'
import tables from './modules/tables'
import reports from './modules/reports'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    auth: auth.state,
    admin: admin.state,
    users: users.state,
    groups: groups.state,
    process: process.state,
    files: files.state,
    tables: tables.state,
    tasks: tasks.state,
    reports: reports.state,
    adminUsersSortField: null,
    adminUsersSortOrder: 'none',
    adminGroupsSortField: null,
    adminGroupsSortOrder: 'none',
    adminExtDbSortField: null,
    adminExtDbSortOrder: 'none',
    adminHqConnSortField: null,
    adminHqConnSortOrder: 'none',
    adminApiSortField: null,
    adminApiSortOrder: 'none',
    adminOpLogSortField: null,
    adminOpLogSortOrder: 'none',
    refreshInterval: null,
    allTasksSortField: '',
    allTasksSortOrder: '',
    databaseTablesSortField: '',
    databaseTablesSortOrder: '',
    documentsSortField: '',
    documentsSortOrder: '',
    formBuilderSortField: '',
    formBuilderSortOrder: '',
    historicCasesSortField: '',
    historicCasesSortOrder: '',
    myTasksSortField: '',
    myTasksSortOrder: '',
    designSortField: '',
    designSortOrder: '',
    deployedSortField: '',
    deployedSortOrder: '',
    reportSortField: '',
    reportSortOrder: '',
    runningCasesSortField: '',
    runningCasesSortOrder: '',
    startCaseSortField: '',
    startCaseSortOrder: '',
    teamTasksSortField: '',
    teamTasksSortOrder: '',
    docTemplateSortField: '',
    docTemplateSortOrder: '',
    emailTemplateSortField: '',
    emailTemplateSortOrder: '',
    unnasignedTasksSortField: '',
    unassignedTasksSortOrder: '',
    viewTableSortOrder: '',
    viewTableSortField: '',
    taskCompleteInt: null,
    token: '',
    currentUser: '',
    currentUserFullname: '',
    currentUserEmail: '',
    tenant: '',
    engineUrl: '',
    randomKey: '',
    xAuthToken: '',
    extAuthToken: '',
    currentRole: '',
    isAdmin: false,
    isDeveloper: false,
    isSupervisor: false,
    isManager: false,
    isLoggedIn: false,
    msalSsoEnabled: false,
    samlSsoEnabled: false,
    ldapEnabled: false,
    userGroups: []
  };
};

const state = getDefaultState();

const mutations = {
  setAdminUsersSortField(state, data) {
    state.adminUsersSortField = data;
  },
  setAdminUsersSortOrder(state, data) {
    state.adminUsersSortOrder = data;
  },
  setAdminGroupsSortField(state, data) {
    state.adminGroupsSortField = data;
  },
  setAdminGroupsSortOrder(state, data) {
    state.adminGroupsSortOrder = data;
  },
  setAdminExtDbSortField(state, data) {
    state.adminExtDbSortField = data;
  },
  setAdminExtDbSortOrder(state, data) {
    state.adminExtDbSortOrder = data;
  },
  setAdminHqConnSortField(state, data) {
    state.adminHqConnSortField = data;
  },
  setAdminHqConnSortOrder(state, data) {
    state.adminHqConnSortOrder = data;
  },
  setAdminApiSortField(state, data) {
    state.adminApiSortField = data;
  },
  setAdminApiSortOrder(state, data) {
    state.adminApiSortOrder = data;
  },
  setAdminOpLogSortField(state, data) {
    state.adminOpLogSortField = data;
  },
  setAdminOpLogSortOrder(state, data) {
    state.adminOpLogSortOrder = data;
  },
  setRefreshInterval(state, data) {
    state.refreshInterval = data;
  },
  setAllTasksSortField(state, data) {
    state.allTasksSortField = data;
  },
  setAllTasksSortOrder(state, data) {
    state.allTasksSortOrder = data;
  },
  setDatabaseTablesSortField(state, data) {
    state.databaseTablesSortField = data;
  },
  setDatabaseTablesSortOrder(state, data) {
    state.databaseTablesSortOrder = data;
  },
  setDocumentsSortField(state, data) {
    state.documentsSortField = data;
  },
  setDocumentsSortOrder(state, data) {
    state.documentsSortOrder = data;
  },
  setFormBuilderSortField(state, data) {
    state.formBuilderSortField = data;
  },
  setFormBuilderSortOrder(state, data) {
    state.formBuilderSortOrder = data;
  },
  setHistoricCasesSortField(state, data) {
    state.historicCasesSortField = data;
  },
  setHistoricCasesSortOrder(state, data) {
    state.historicCasesSortOrder = data;
  },
  setMyTasksSortField(state, data) {
    state.myTasksSortField = data;
  },
  setMyTasksSortOrder(state, data) {
    state.myTasksSortOrder = data;
  },
  setDesignSortField(state, data) {
    state.designSortField = data;
  },
  setDesignSortOrder(state, data) {
    state.designSortOrder = data;
  },
  setDeployedSortField(state, data) {
    state.deployedSortField = data;
  },
  setDeployedSortOrder(state, data) {
    state.deployedSortOrder = data;
  },
  setReportSortField(state, data) {
    state.reportSortField = data;
  },
  setReportSortOrder(state, data) {
    state.reportSortOrder = data;
  },
  setRunningCasesSortField(state, data) {
    state.runningCasesSortField = data;
  },
  setRunningCasesSortOrder(state, data) {
    state.runningCasesSortOrder = data;
  },
  setStartCaseSortField(state, data) {
    state.startCaseSortField = data;
  },
  setStartCaseSortOrder(state, data) {
    state.startCaseSortOrder = data;
  },
  setTeamTasksSortField(state, data) {
    state.teamTasksSortField = data;
  },
  setTeamTasksSortOrder(state, data) {
    state.teamTasksSortOrder = data;
  },
  setDocTemplateSortField(state, data) {
    state.docTemplateSortField = data;
  },
  setDocTemplateSortOrder(state, data) {
    state.docTemplateSortOrder = data;
  },
  setEmailTemplateSortField(state, data) {
    state.emailTemplateSortField = data;
  },
  setEmailTemplateSortOrder(state, data) {
    state.emailTemplateSortOrder = data;
  },
  setUnnasignedTasksSortField(state, data) {
    state.unnasignedTasksSortField = data;
  },
  setUnassignedTasksSortOrder(state, data) {
    state.unassignedTasksSortOrder = data;
  },
  setViewTableSortOrder(state, data) {
    state.viewTableSortOrder = data;
  },
  setViewTableSortField(state, data) {
    state.viewTableSortField = data;
  },
  setTaskCompleteInt(state, data) {
    state.taskCompleteInt = data;
  },
  setToken(state, data) {
    state.token = data;
  },
  setCurrentUser(state, data) {
    state.currentUser = data;
  },
  setCurrentUserFullname(state, data) {
    state.currentUserFullname = data;
  },
  setCurrentUserEmail(state, data) {
    state.currentUserEmail = data;
  },
  setTenant(state, data) {
    state.tenant = data;
  },
  setEngineUrl(state, data) {
    state.engineUrl = data;
  },
  setRandomKey(state, data) {
    state.randomKey = data;
  },
  setXAuthToken(state, data) {
    state.xAuthToken = data;
  },
  setExtAuthToken(state, data) {
    state.extAuthToken = data;
  },
  setCurrentRole(state, data) {
    state.currentRole = data;
  },
  setIsAdmin(state, data) {
    state.isAdmin = data;
  },
  setIsDeveloper(state, data) {
    state.isDeveloper = data;
  },
  setIsSupervisor(state, data) {
    state.isSupervisor = data;
  },
  setIsManager(state, data) {
    state.isManager = data;
  },
  setIsLoggedIn(state, data) {
    state.isLoggedIn = data;
  },
  setMsalSsoEnabled(state, data) {
    state.msalSsoEnabled = data;
  },
  setSamlSsoEnabled(state, data) {
    state.samlSsoEnabled = data;
  },
  setLdapEnabled(state, data) {
    state.ldapEnabled = data;
  },
  setUserGroups(state, data) {
    state.userGroups = data;
  },
  reset(state) {
    const defaultState = getDefaultState();
    Object.keys(state).forEach(key => {
      state[key] = defaultState[key];
    });
  }
};

const actions = {
  clearAll({commit}){   
    commit('reset')
  }
};

const modules = {
  auth,
  admin,
  process,
  tasks,
  users,
  groups,
  files,
  tables,
  reports
};

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  modules,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer: (state) => ({
        adminUsersSortField: state.adminUsersSortField,
        adminUsersSortOrder: state.adminUsersSortOrder,
        adminGroupsSortField: state.adminGroupsSortField,
        adminGroupsSortOrder: state.adminGroupsSortOrder,
        adminExtDbSortField: state.adminExtDbSortField,
        adminExtDbSortOrder: state.adminExtDbSortOrder,
        adminHqConnSortField: state.adminHqConnSortField,
        adminHqConnSortOrder: state.adminHqConnSortOrder,
        adminApiSortField: state.adminApiSortField,
        adminApiSortOrder: state.adminApiSortOrder,
        adminOpLogSortField: state.adminOpLogSortField,
        adminOpLogSortOrder: state.adminOpLogSortOrder,
        refreshInterval: state.refreshInterval,
        allTasksSortField: state.allTasksSortField,
        allTasksSortOrder: state.allTasksSortOrder,
        databaseTablesSortField: state.databaseTablesSortField,
        databaseTablesSortOrder: state.databaseTablesSortOrder,
        documentsSortField: state.documentsSortField,
        documentsSortOrder: state.documentsSortOrder,
        formBuilderSortField: state.formBuilderSortField,
        formBuilderSortOrder: state.formBuilderSortOrder,
        historicCasesSortField: state.historicCasesSortField,
        historicCasesSortOrder: state.historicCasesSortOrder,
        myTasksSortField: state.myTasksSortField,
        myTasksSortOrder: state.myTasksSortOrder,
        designSortField: state.designSortField,
        designSortOrder: state.designSortOrder,
        deployedSortField: state.deployedSortField,
        deployedSortOrder: state.deployedSortOrder,
        reportSortField: state.reportSortField,
        reportSortOrder: state.reportSortOrder,
        runningCasesSortField: state.runningCasesSortField,
        runningCasesSortOrder: state.runningCasesSortOrder,
        startCaseSortField: state.startCaseSortField,
        startCaseSortOrder: state.startCaseSortOrder,
        teamTasksSortField: state.teamTasksSortField,
        teamTasksSortOrder: state.teamTasksSortOrder,
        docTemplateSortField: state.docTemplateSortField,
        docTemplateSortOrder: state.docTemplateSortOrder,
        emailTemplateSortField: state.emailTemplateSortField,
        emailTemplateSortOrder: state.emailTemplateSortOrder,
        unnasignedTasksSortField: state.unnasignedTasksSortField,
        unassignedTasksSortOrder: state.unassignedTasksSortOrder,
        viewTableSortOrder: state.viewTableSortOrder,
        viewTableSortField: state.viewTableSortField,
        taskCompleteInt: state.taskCompleteInt,
        token: state.token,
        currentUser: state.currentUser,
        currentUserFullname: state.currentUserFullname,
        currentUserEmail: state.currentUserEmail,
        tenant: state.tenant,
        engineUrl: state.engineUrl,
        randomKey: state.randomKey,
        xAuthToken: state.xAuthToken,
        extAuthToken: state.extAuthToken,
        currentRole: state.currentRole,
        isAdmin: state.isAdmin,
        isDeveloper: state.isDeveloper,
        isSupervisor: state.isSupervisor,
        isManager: state.isManager,
        isLoggedIn: state.isLoggedIn,
        msalSsoEnabled: state.msalSsoEnabled,
        samlSsoEnabled: state.samlSsoEnabled,
        ldapEnabled: state.ldapEnabled,
        userGroups: state.userGroups
      })
    })
  ]
});

export default store;
